const getFirstDayOfLastYear = () => {
  const now = new Date();
  const lastYear = now.getFullYear() - 1;

  return new Date(lastYear, 0, 1);
};

export default getFirstDayOfLastYear;
